import * as types from './mutation-types';

import {_Vue} from '../../index';
import originData from './state';
const cloneOriginData = JSON.parse(JSON.stringify(originData));
const mutations = {
  [types.INIT_PLAYER_DATA](state, data) {
    Object.keys(data).forEach((key) => {
      _Vue.set(state, key, data[key]);
    });
  },
  [types.CLEAR_OLD_PLAYER_DATA](state) {
    Object.keys(cloneOriginData).forEach((key) => {
      _Vue.set(state, key, cloneOriginData[key]);
    });
  },
  [types.SET_SPEED](state, speed) {
    state.speed = speed;
  },
  [types.SET_POP_MENU_SHOW](state, showState) {
    state.popMenuShow = showState;
  },
  [types.SET_POP_MARKER_SHOW](state, showState) {
    state.popMarkerShow = showState;
  }
};
export default mutations;
